// src/lib/serviceCategories.js
import api, { withBusiness } from "./api";

/**
 * Lista categorii (persistente) pentru servicii
 * GET /api/b/:businessId/service-categories/
 */
export async function listServiceCategories() {
  const url = withBusiness("/b/:businessId/service-categories/");
  const { data } = await api.get(url);
  return Array.isArray(data?.results) ? data.results : data;
}

/**
 * Creează categorie nouă (idempotent - dacă există deja, întoarce categoria existentă)
 * POST /api/b/:businessId/service-categories/
 */
export async function createServiceCategory(payload) {
  const url = withBusiness("/b/:businessId/service-categories/");
  const { data } = await api.post(url, payload);
  return data;
}
